import script from "./Translator.vue?vue&type=script&setup=true&lang=js"
export * from "./Translator.vue?vue&type=script&setup=true&lang=js"

import "./Translator.vue?vue&type=style&index=0&id=40e80d3a&lang=scss"

const __exports__ = script;

export default __exports__